// @ts-ignore
import React, { Suspense } from "react";

import { defineMessages, useIntl } from "react-intl";

import {
    PriceFinderMessages,
    SpecialPlanNames
} from "@/components/wpl/pricing/src/price-finder/constants.tsx";
import { PriceCardProductPlan } from "@/components/wpl/pricing/src/price-finder/price-card/card-container.tsx";
import { PriceFinderContextProvider } from "@/components/wpl/pricing/src/price-finder/price-finder-context.tsx";
import PriceFinderSection from "@/components/wpl/pricing/src/price-finder/price-finder.tsx";
import { createPlanFeatureMessages } from "@/components/wpl/pricing/src/price-finder/utils/create-price-finder-features.tsx";
import { usePricingPlanComparison } from "@/components/wpl/pricing/src/pricing-content-context.tsx";
import { CTA_URL_PATH } from "@/templates/collections/strategy/pricing/sections/urls.ts";
import { UserLocale } from "@/utils/useGeoCurrency.ts";

import { AppPricingData } from "../../../../../contentful/index.tsx";

import { Disclaimer } from "./disclaimer.tsx";

export interface StrategyCollectionPriceFinderProps {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
}

export const StrategyCollectionPriceFinder = (
    props: StrategyCollectionPriceFinderProps
) => {
    // @ts-ignore
    const intl = useIntl();

    const content = {
        enterprise: usePricingPlanComparison("Strategy Collection") // please ensure this matches the plan-comparison entry in Contentful
    };

    const enterprisePlanFeatureMessages = createPlanFeatureMessages(
        content,
        "enterprise"
    );

    const productPlans: PriceCardProductPlan[] = [
        {
            planName: SpecialPlanNames.ENTERPRISE,
            planTitleComponent: () => <>Strategy Collection</>,
            offeringSku: "strategy-collection-enterprise-sku",
            recommendationLimit: 2000,
            signupLimit: 2000,
            planFeatureMessages: enterprisePlanFeatureMessages,
            signupURLInfo: {
                urlDomain: window.location.origin,
                urlPath: CTA_URL_PATH,
                shouldLocalize: true
            }
        }
    ];

    const messages: PriceFinderMessages = defineMessages({
        unitCountInputTextRedesign: {
            id: "StrategyCollectionPriceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size"
        },
        unitCountInputTerm: {
            id: "StrategyCollectionPriceFinder.unitCountInputTerm",
            defaultMessage: "users"
        },
        cardUnitCountTierRange: {
            id: "StrategyCollectionPriceFinder.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardEnterpriseMinimumCount: {
            id: "StrategyCollectionPriceFinder.cardEnterpriseMinimumCount",
            defaultMessage:
                "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above"
        }
    });

    return (
        <Suspense>
            <PriceFinderContextProvider
                dataProductKey="strategyCollection"
                productPlans={productPlans}
                defaultUnitCount={50}
                isAnnualBillingOnly={true}
                enterpriseMinimumCount={50}
                contactURL={CTA_URL_PATH}
            >
                <div>
                    <PriceFinderSection
                        messages={messages}
                        serverSideCCPPricing={
                            props.pricing?.ccpPricingData?.strategyCollection
                        }
                        countryCode={props.countryCode}
                    />
                    <Disclaimer />
                </div>
            </PriceFinderContextProvider>
        </Suspense>
    );
};
